export default {
  title: 'shipping companies',
  refNumber: 'refrence number',
  balanceAmount: 'balance amount',
  add: 'add shipping company',
  update: 'update shipping company',
};
